import React, { useEffect, useState } from "react";
import axios from "axios";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import SmallLoader from "../../Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import Form from "react-bootstrap/Form";
import SummaryReactivationGraph from "../../Graphs/SummaryReactivationGraph";
import {
  AESEncryption,
  ApiResDecrypt,
  getTabStatus,
  goToClientDashboard,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Modal } from "react-bootstrap";
import LoaderForSearch from "../../Common/LoaderForSearch";
import Loader from "../../Common/Loader";
import { toast } from "react-toastify";

function SummaryReactivation() {
  const storeToken = localStorage.getItem("ssoToken");
  const [loader, setLoader] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [value, setValue] = useState("HNI");
  const [stageUpdate, setClientStage] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [bothData, setBothData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [hniRetailData, setHniRetailData] = useState({});
  const [serverError, setServerError] = useState(false);
  const [count, setCount] = useState();
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);

  const getSummaryData = async () => {
    setLoader(true);
    let payloadValue = {
      seg: value,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSummary = await axios.post(
        DASHBOARD_DEFAULT.SummaryReactivation_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      let response = ApiResDecrypt(getSummary?.data);
      if (response?.status === 0) {
        setHniRetailData(response?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const handleOnChange = (e) => {
    if (e.target.value) {
      setValue(e.target.value);
      setHniRetailData({});
    }
  };

  //Summary detail api section start
  const getSummaryDetailData = async (
    stages,
    typeView = "grid",
    pageSize = 10
  ) => {
    if (page === 1 && typeView === "grid") {
      setModalLoader(true);
    }
    if (typeView === "excel") {
      setSmallLoaderExcel(true);
    }
    if (typeView === "pdf") {
      setSmallLoaderPdf(true);
    }
    let payloadValue = {
      pageSize: pageSize,
      pageNo: page,
      seg: value,
      type: stages,
      fileType: typeView,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetail = await axios.post(
        DASHBOARD_DEFAULT.SummaryReactivationDetail_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetail?.data);
      if (response?.status === 0) {
        setServerError(false);
        setCount(response?.data?.totalCount);
        if (typeView === "grid") {
          if (page > 1) {
            setBothData((prev) => {
              return [...prev, ...response?.data?.clientList];
            });
          } else {
            setBothData(response?.data?.clientList);
          }
        } else if (typeView === "excel") {
          window.open(response?.data, "_self", "noopener,noreferrer");
        } else if (typeView === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (typeView !== "grid") {
          toast.error(response?.message);
        }
      }
    } catch (error) {
      console.log(error);
      if (typeView === "grid") {
        setServerError(error.message);
      } else {
        toast.error(error.message);
      }
      // setServerError(error.message);
    } finally {
      if (page === 1 && typeView === "grid") {
        setModalLoader(false);
      }
      if (typeView === "excel") {
        setSmallLoaderExcel(false);
      }
      if (typeView === "pdf") {
        setSmallLoaderPdf(false);
      }
      if (page > 1) {
        setScrollLoader(false);
      }
      // setModalLoader(false);
      // setSmallLoaderExcel(false);
      // setSmallLoaderPdf(false);
    }
  };

  const handleViewClick = (stage) => {
    setClientStage(stage);
    getSummaryDetailData(stage, "grid", 10);
    setModalTitle(stage);
    setShowModal(true);
  };

  const handleScroll = async (e) => {
    if (showModal) {
      const a = e.target;
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
        if (!(count <= 10 * page)) {
          setPage((prev) => prev + 1);
          setScrollLoader(true);
        }
      }
    }
  };

  //Summary detail api section end

  const onHide = () => {
    setShowModal(false);
    setPage(1);
    setBothData([]);
  };

  useEffect(() => {
    getSummaryData();
  }, [value]);

  useEffect(() => {
    if (showModal) {
      getSummaryDetailData(stageUpdate, "grid", 10);
    }
  }, [page, value]);

  const handleOnClick = (e) => {
    getSummaryDetailData(stageUpdate, e.target.value, -1);
  };

  return (
    <div>
      <div className="card-box summary-block">
        <div className="card-title">
          <h2>{Constants.Summary_Reactivation}</h2>
          <div className="dropdown-filter">
            <Form.Select
              size="lg"
              aria-label="Default select example"
              onChange={handleOnChange}
            >
              <option value="HNI">{Constants.HNI}</option>
              <option value="RETAIL">{Constants.Retail}</option>
            </Form.Select>
          </div>
        </div>
        <div className="summary-tab-details">
          <div className="tab-left">
            <SummaryReactivationGraph
              hniRetailData={hniRetailData}
              title={hniRetailData?.total ? hniRetailData?.total : 0}
            />
            <div className="sum-tab-list">
              <ul>
                <li>
                  <h3>{Constants.Inactive}</h3>

                  <div className="sum-tab-item">
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <h4 onClick={() => handleViewClick("intotal")}>
                        {hniRetailData?.aboveSixMnthTotal
                          ? hniRetailData?.aboveSixMnthTotal
                          : 0}
                      </h4>
                    )}
                    <p>
                      <span className="total-color"></span>
                      {loader ? (
                        <SmallLoader />
                      ) : (
                        <>
                          {hniRetailData?.aboveSixMnthPer
                            ? hniRetailData?.aboveSixMnthPer.toFixed(2)
                            : 0}
                          %
                        </>
                      )}
                    </p>
                  </div>

                  <p>{Constants.Clients_Inactive_Duration}</p>
                </li>
                <li>
                  <h3>{Constants.Moderately_Active}</h3>

                  <div className="sum-tab-item">
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <h4 onClick={() => handleViewClick("inservice")}>
                        {hniRetailData?.threeTosixMnthTotal
                          ? hniRetailData?.threeTosixMnthTotal
                          : 0}
                      </h4>
                    )}

                    <p>
                      <span className="service-color"></span>
                      {loader ? (
                        <SmallLoader />
                      ) : (
                        <>
                          {hniRetailData?.threeTosixMnthPer
                            ? hniRetailData?.threeTosixMnthPer.toFixed(2)
                            : 0}
                          %
                        </>
                      )}
                    </p>
                  </div>

                  <p>
                    {
                      "Client inactive for > 3 but < 6 months Average revenue is for 2000.00"
                    }
                  </p>
                </li>
                <li>
                  <h3>{Constants.Semi_Active}</h3>
                  <div className="sum-tab-item">
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <h4 onClick={() => handleViewClick("inhandover")}>
                        {hniRetailData?.threeMnthTotal
                          ? hniRetailData?.threeMnthTotal
                          : 0}
                      </h4>
                    )}
                    <p>
                      <span className="handover-color"></span>
                      {loader ? (
                        <SmallLoader />
                      ) : (
                        <>
                          {hniRetailData?.threeMnthPer
                            ? hniRetailData?.threeMnthPer.toFixed(2)
                            : 0}
                          %
                        </>
                      )}
                    </p>
                  </div>

                  <p>{Constants.Average_revenue}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Modal start */}

      <Modal
        show={showModal}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model naked-debit-model-wrapper summary-reactivation"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h2 className="model-title">
              {modalTitle === "intotal"
                ? "Total Inactive"
                : modalTitle === "inservice"
                ? "Moderately Active"
                : "Semi Active"}
            </h2>
          </Modal.Title>
          <div className="btn-wrapper-summary">
            <button
              value="excel"
              onClick={handleOnClick}
              className="summary-btn excel-btn"
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  Excel
                </>
              )}
            </button>
            <button
              className="summary-btn pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  PDF
                </>
              )}
            </button>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onHide}
            >
              <span className="icon-close"></span>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="setting">
            <div className="naked-debit-model table-responsive scroll-table summary-reactivate-modal">
              {modalLoader ? (
                <div className="loader-alignment">
                  <Loader />
                </div>
              ) : bothData && bothData.length > 0 ? (
                <table className="table">
                  <thead>
                    <tr>
                      <th>{Constants.Client_Code}</th>
                      <th>{Constants.client_Name}</th>
                      <th>Mobile Number</th>
                    </tr>
                  </thead>
                  <tbody onScroll={(e) => handleScroll(e)}>
                    {bothData &&
                      bothData.map((element, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <a
                                href="/client-dashboard"
                                onClick={() => {
                                  goToClientDashboard(element?.clientCode, "");
                                  getTabStatus("")
                                }}
                              >
                                {element?.clientCode || "-"}
                              </a>
                            </td>
                            <td>{element?.clientName || "-"}</td>
                            <td>{element?.mobileNumber || "-"}</td>
                          </tr>
                        );
                      })}
                    {scrollLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </tbody>
                </table>
              ) : (
                !serverError && noDataFound()
              )}
              {serverError && (
                <h4 className="no-data">{noDataFound(serverError)}</h4>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal end */}
    </div>
  );
}

export default SummaryReactivation;
